import React from 'react';
import { Lifecycle } from '../constants/hooks';

import IChannel from '../channel/index';
import Cmd from './cmd';
import Libraray from './libraray';
import { IMessage } from './message';
import { Spectator } from './spectator';

export type VoidFunction = () => void;
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export type AnyAsyncFunction = (...args: any) => any;

export type ExtraInfo = Record<string, any>;

type LogFunc = (content: string, extra?: ExtraInfo) => void;

export interface ILogger {
  print: LogFunc;
  debug: LogFunc;
  info: LogFunc;
  warn: LogFunc;
  error: LogFunc;
  fatal: LogFunc;
}

export enum LifeStatus {
  willInit = 0,
}
export enum ELang {
  zh = 'zh-CN',
  es = 'es',
}
export interface IThemes {
  'primary-color'?: string;
  'divider-color'?: string;
  'container-bg'?: string;
  'container-font-color'?: string;
  'light-bg-color'?: string;
  'container-font-size'?: string;
  'container-font-family'?: string;
  'tool-icon-border-radius'?: string;
  'tool-icon-bg'?: string;
  'tool-icon-color'?: string;
  'optional-icon-size'?: string;
  'optional-bg'?: string;
  'optional-icon-color'?: string;
  'tool-panel-bg'?: string;
  'tool-panel-border-radius'?: string;
  'emoji-panel-bg'?: string;
  'emoji-panel-border-radius'?: string;
  'input-bg'?: string;
  'input-font-color'?: string;
  'input-border-radius'?: string;
  'nav-bg'?: string;
  'nav-font-color'?: string;
  'scroll-bottom-bg'?: string;
  'scroll-bottom-color'?: string;
  'unread-count-bg'?: string;
  'unread-count-color'?: string;
  [propsName: string]: string | undefined;
}
export type makeChannelFunction<T> = (appCtx: T) => Promise<any>;

export interface IMessageContext<T extends IMessage = IMessage> {
  appContext: IAppContext<T>;
  message: T;
}

export type AutoCompleteFunc<T extends IMessage = IMessage> = (
  keywords: string,
  appContext?: IAppContext<T>,
) => Promise<{
  list: Array<Record<string, any>>;
  keywords?: string;
}>;

export interface IAutoComplete {
  onClick?: (appContext: IAppContext, query: any) => boolean | void;
  getData?: AutoCompleteFunc;
  labelKey?: string;
}
export interface IAppContext<T = IMessage, C = IChannel<any>> {
  $refs?: any;
  logger?: ILogger;
  libraray: Libraray;
  triggerEvent?: (eventCode: string, data: any) => any;
  triggerComEvent?: (
    eventCode: string,
    params?: { rootMessageId?: string; serverId?: string },
  ) => any;
  cmd?: Cmd;
  query: Record<string, string | boolean>;
  userInfo: {
    /** 业务线ID */
    businessLineId?: string;
    /** 用户唯一ID */
    userId?: string;
  } & {
    [key: string]: string;
  };
  renderConfig: any;
  autoComplete?: IAutoComplete;
  jsBrige?: any;
  utils?: any;
  messages: Array<T>;
  dialogInfo: any;
  appLoading?: boolean;
  appStatus: Lifecycle;
  watchOfflineForm: any;
  dialog?: any;
  channel?: C;
  sendMessage?: AnyAsyncFunction;
  sendFile?: AnyAsyncFunction;
  appendMessage?: AnyAsyncFunction;
  cmdRender?: AnyAsyncFunction;
  ext?: any;
  watchAppDidMount?: any;
  themes?: IThemes;
  lang?: string;
  mountId?: HTMLDivElement;
  eventBus?: Spectator;
  jarvisPlugin: any;
  replyMessage: any;
}

export interface IMessageCtx<T extends IMessage = IMessage> {
  message: T;
  appContext: IAppContext<T>;
}

export interface ILifecycle {
  [propName: string]: any;
}

export interface IScoket {
  sendMessage: AnyAsyncFunction;
}

export type MiddleWare<T extends IMessage = IMessage> = (
  ctx: IMessageCtx<T>,
  next: any,
) => Promise<void>;

/**
 * @field layout 部署配置
 * @field utils 工具
 * @field jsBrige jsBrige
 * @field lifecycle 生命周期
 * @field components 默认注册的组件
 * @field getUniqueId 获取消息唯一ID
 * @field plugins 插件
 * @field middleware 中间件
 * @field lang 语言
 * @field makeChannel 通道初始化
 * @field theme 主题配置
 */
declare interface IBaseConfig<T extends IMessage = IMessage> {
  baseUrl?: string;
  autoComplete?: IAutoComplete;
  createDialog?: (appContext: IAppContext<T>) => Promise<any> | any;
  layout?: any;
  utils?: any;
  jsBrige?: any;
  lifecycle: Record<string, AnyAsyncFunction>;
  query?: Record<string, string | boolean>;
  components?: Record<string, React.Component | ((props: any) => JSX.Element)>;
  plugins?: ILifecycle;
  middleware?: {
    send: MiddleWare<T>[];
    receive: MiddleWare<T>[];
  };
  themes?: IThemes;
  lang?: string;
  makeChannel?: makeChannelFunction<IAppContext<T>>;
  logger?: any;
}

export { IBaseConfig };

type If<C, T, F> = C extends boolean ? T : F;

export interface IComponent {
  code: string;
  version: string;
  isRemote?: boolean;
  meta?: Record<string, any>;
  config?: Record<string, any>;
  component: any;
}
